import { createContext } from 'react'

export let FormKeyContext = createContext<string | undefined>(undefined)
